module.exports = __webpack_public_path__ + "img/hy2.c2c46ff2.png";